import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/external-data-sets/by-slug/{slug}']['GET'];
type Input = ThisApi['params'];

const getDataReferenceBySlug = async ({ slug }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/external-data-sets/by-slug/{slug}', { slug });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getDataReferenceBySlug;
